import { setList } from './listConfig';
import { setDetail } from './detailConfig';
import { setDetail2 } from './detailConfig2';

export default function setTableCols (type = 'list') {
  const configs = {
    'list': setList.call(this),
    'detail': setDetail.call(this),
    'detail2': setDetail2.call(this),
  };

  configs[type].forEach(v => {
    if (!v.minWidth) {
      let title = v.label || v.title;

      v.minWidth = `${title.length * 16 + (v.sortable ? 30 : 20)}px`;
    }

    v.tooltip = true;
  });

  return configs[type];
}
